import { COMPANY_NAME, COMPANY_PHONE } from '@/constants';
import { POS_PRINT_BOLD_FONT_WEIGHT } from './PosPrint.utils';

interface HeaderProps {
  title?: string;
}

export function Header({
  title = `${COMPANY_NAME} - ${COMPANY_PHONE}`,
}: HeaderProps) {
  return (
    <div>
      <p
        style={{
          fontWeight: POS_PRINT_BOLD_FONT_WEIGHT,
          textAlign: 'center',
        }}
      >
        {title}
      </p>
    </div>
  );
}
